export const dateTimeStandard = "dd. MMMM yyyy, HH:mm";
export const dateTimeEvent = "dd.MM.";
export const dateTimeEventEnd = "dd.MM.YYYY"
export const dateYear = "YYYY";
